import { useTheme } from '@/contexts/theme'

import { cn } from '@/lib/utils'

type DarkModeToggleProps = {
  className?: string
}

const DarkModeToggle = ({ className }: DarkModeToggleProps) => {
  const { isDarkMode, toggleDarkMode } = useTheme()

  return (
    <button
      onClick={toggleDarkMode}
      className={cn(
        'relative flex h-[2.4rem] w-[4.8rem] items-center rounded-full transition-colors duration-300',
        isDarkMode ? 'bg-text-heading' : 'bg-border-primary',
        className
      )}
      aria-label={
        isDarkMode ? 'Attiva modalità chiara' : 'Attiva modalità scura'
      }
    >
      <span
        className={cn(
          'absolute h-[2rem] w-[2rem] rounded-full transition-transform duration-300'
        )}
      >
        {isDarkMode ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className="text-text-heading m-auto h-[1.2rem] w-[1.2rem] transform transition-transform duration-300"
            aria-hidden="true"
            fill="currentColor"
          >
            <circle cx="12" cy="12" r="4" />
            <g
              stroke="currentColor"
              strokeWidth="1.4"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
            >
              <line x1="12" y1="1.5" x2="12" y2="3.5" />
              <line x1="12" y1="20.5" x2="12" y2="22.5" />
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
              <line x1="1.5" y1="12" x2="3.5" y2="12" />
              <line x1="20.5" y1="12" x2="22.5" y2="12" />
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
            </g>
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className="text-text-heading m-auto h-[1.2rem] w-[1.2rem] transform transition-transform duration-300"
            aria-hidden="true"
            fill="currentColor"
          >
            <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
          </svg>
        )}
      </span>
    </button>
  )
}

export default DarkModeToggle
